import AddInfoModal from './AddInfoModal';

export default AddInfoModal;
